import * as constants from "./constants";

export const fetchClassesStudents = () => ({
  type: constants.FETCH_CLASSES_STUDENTS,
});

export const fetchClassesStudentsSuccess = (payload) => ({
  type: constants.FETCH_CLASSES_STUDENTS_SUCCESS,
  payload,
});

export const fetchClassesStudentsError = (error) => ({
  type: constants.FETCH_CLASSES_STUDENTS_ERROR,
  error,
});

export const reviewReport = (payload) => ({
  type: constants.REVIEW_REPORT,
  payload,
});

export const reviewReportSuccess = (data) => ({
  type: constants.REVIEW_REPORT_SUCCESS,
  payload: data,
});

export const reviewReportError = (error) => ({
  type: constants.REVIEW_REPORT_ERROR,
  error,
});

export const setSelectedClass = (class_id) => ({
  type: constants.SET_SELECTED_CLASS,
  payload: class_id,
});

export const setSelectedStudent = (student_id) => ({
  type: constants.SET_SELECTED_STUDENT,
  payload: student_id,
});

export const setReportData = (payload) => ({
  type: constants.SET_REPORT_DATA,
  payload,
});


export const generateReport = (payload) => ({
  type: constants.GENERATE_REPORT,
  payload,
});

export const generateReportSuccess = (data) => ({
  type: constants.GENERATE_REPORT_SUCCESS,
  data,
});

export const generateReportError = (error) => ({
  type: constants.GENERATE_REPORT_ERROR,
  error,
});